import { Injectable } from '@tanbo/vue-di-plugin'
import { TableList, TableMemoryPagination } from '@/services/table-memory-pagination'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import {
  AbstractTerminalViewService,
  BlockQueryParams
} from '@/views/dashboard/manage/port-manage/_components/abstract-terminal-view/abstract-terminal-view.service'
import { BlockPortItem, ResetBlockRuleParams } from '@/views/dashboard/manage/port-manage/_components/block-view/block-view.service'

export interface QueryParams {
  /** 规则id */
  rule_id: number
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 是否使用内存数据 */
  useMemory: boolean
  /** 系统类型 1-windows 2-linux 3-win server 4-mac */
  system_types: number[]
}

export interface TerminalItem {
  /** 设备id */
  device_id: string
  /** 终端名 */
  computer_name: string
  /** 分组名 */
  group_name: string
  /** IP地址 */
  system_ip: string
  /** 绑定IP */
  bind_ip: string
  /** 监听的进程名 */
  process_name: string
  /** 登录状态,1->在线，2->离线 */
  login_status: number
  /** 系统类型 1-windows 2-linux */
  system_type?: number
}
export interface BlockRuleParams {
  /** 选择类型,0-指定终端，1-指定分组, 2-指定端口的全部终端 */
  select_type: number
  /** 端口阻断起点 */
  port_start: number
  /** 端口阻断终点, 起点终点相同时表示只阻断一个端口 */
  port_end: number
  /** 终端设备id列表 */
  device_list?: string[]
  /** 分组id */
  group_id?: number
  /** 系统类型 1-windows 2-linux 3-win server 4-mac */
  system_types: number[]
  port_list:Port[]
}
export interface Port{
   /** 端口号 */
  port: number
  /** 系统类型,0-全部，1-windows,2-linux，3-windows server，4-mac */
  system_type: number
}
const commonQueryParams = {
  page: 1,
  limit: 10,
  asc: false,
  sort: 'computer_name',
  useMemory: false
}
@Injectable()
export class BlockViewDrawerService extends TableMemoryPagination<QueryParams, TerminalItem> implements AbstractTerminalViewService {
  selectItem: BlockPortItem
  constructor (private http: Http) {
    super()
  }

  isEqual (left: TerminalItem, right: TerminalItem): boolean {
    return left.device_id === right.device_id
  }

  getSelectItem (): BlockPortItem {
    return this.selectItem
  }

  getQueryParams (): BlockQueryParams {
    return Object.assign({}, commonQueryParams, {
      rule_id: this.getSelectItem().rule_id,
      system_types: [this.getSelectItem().system_type]
    })
  }

  @ParamsClean()
  getListByServer (params: QueryParams): Promise<TableList<TerminalItem>> {
    const newParams = Object.assign({}, params, { rule_id: this.getSelectItem().rule_id })
    return this.http.post<{
      list: TerminalItem[]
      total: number
    }>('/portcontrol/blocked-rules/device-list', newParams)
  }

  @InvokeThrottle()
  resetBlockRule (data: ResetBlockRuleParams) {
    return this.http.post<void>('/portcontrol/blocked-rule/cancel', data)
  }

  addBlockRule (data: BlockRuleParams) {
    return this.http.post<void>('/portcontrol/blocked-rule/save', data)
  }
}
